var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layouts-filter-controls" }, [
    _c(
      "div",
      {
        staticClass: "layouts-filter-controls__search",
        attrs: { id: "reports-search-input" },
      },
      [
        _c("div", { staticClass: "input-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.search,
                expression: "search",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Search..." },
            domProps: { value: _vm.search },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.search = $event.target.value
                },
                _vm.emitFiltersDebounced,
              ],
            },
          }),
          _vm._v(" "),
          _vm.search
            ? _c(
                "button",
                {
                  staticClass: "btn layouts-filter-controls__search-clear",
                  attrs: { type: "button" },
                  on: { click: _vm.clearSearch },
                },
                [_c("i", { staticClass: "bi bi-x" })]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "input-group-append" }, [
            _c(
              "div",
              {
                ref: "settingsDropdown",
                staticClass:
                  "dropdown layouts-filter-controls__search-settings",
                attrs: { id: "searchSettings" },
              },
              [
                _c(
                  "button",
                  {
                    ref: "settingsButton",
                    staticClass: "btn layouts-top__icon-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleSettings.apply(null, arguments)
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-sliders" })]
                ),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.settingsOpen,
                        expression: "settingsOpen",
                      },
                    ],
                    staticClass: "dropdown-menu show pt-3 px-3 pb-0",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _vm._m(1),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group form-check" }, [
                      _c(
                        "label",
                        { staticClass: "form-check-label cursor-pointer" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchProjects,
                                expression: "searchProjects",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.searchProjects)
                                ? _vm._i(_vm.searchProjects, null) > -1
                                : _vm.searchProjects,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.searchProjects,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.searchProjects = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.searchProjects = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.searchProjects = $$c
                                  }
                                },
                                _vm.emitFilters,
                              ],
                            },
                          }),
                          _vm._v("\n                Projects\n              "),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group form-check" }, [
                      _c(
                        "label",
                        { staticClass: "form-check-label cursor-pointer" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchProductId,
                                expression: "searchProductId",
                              },
                            ],
                            staticClass: "form-check-input",
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.searchProductId)
                                ? _vm._i(_vm.searchProductId, null) > -1
                                : _vm.searchProductId,
                            },
                            on: {
                              change: [
                                function ($event) {
                                  var $$a = _vm.searchProductId,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.searchProductId = $$a.concat([
                                          $$v,
                                        ]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.searchProductId = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.searchProductId = $$c
                                  }
                                },
                                _vm.emitFilters,
                              ],
                            },
                          }),
                          _vm._v(
                            "\n                Product ID\n              "
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "filtersDropdown",
        staticClass: "dropdown ml-2",
        attrs: { id: "filterDropdown" },
      },
      [
        _c(
          "button",
          {
            staticClass: "btn btn-primary dropdown-toggle",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                _vm.filtersOpen = !_vm.filtersOpen
              },
            },
          },
          [_c("i", { staticClass: "bi bi-funnel" }), _vm._v(" Filters\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.filtersOpen,
                expression: "filtersOpen",
              },
            ],
            staticClass: "dropdown-menu dropdown-menu-right lm-filters show",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
              mousedown: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "lm-filters__body" },
              [
                _c("div", { staticClass: "lm-filters__toggles" }, [
                  _c("div", [
                    _c(
                      "label",
                      { staticClass: "form-check-label cursor-pointer mb-0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showQaLayouts,
                              expression: "showQaLayouts",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.showQaLayouts)
                              ? _vm._i(_vm.showQaLayouts, null) > -1
                              : _vm.showQaLayouts,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = _vm.showQaLayouts,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.showQaLayouts = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.showQaLayouts = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.showQaLayouts = $$c
                                }
                              },
                              _vm.emitFilters,
                            ],
                          },
                        }),
                        _vm._v("\n              Show QA layouts\n            "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "label",
                      { staticClass: "form-check-label cursor-pointer mb-0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.showOnlyFavorites,
                              expression: "showOnlyFavorites",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.showOnlyFavorites)
                              ? _vm._i(_vm.showOnlyFavorites, null) > -1
                              : _vm.showOnlyFavorites,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = _vm.showOnlyFavorites,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.showOnlyFavorites = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.showOnlyFavorites = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.showOnlyFavorites = $$c
                                }
                              },
                              _vm.emitFilters,
                            ],
                          },
                        }),
                        _vm._v("\n              Favorites\n            "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "label",
                      { staticClass: "form-check-label cursor-pointer mb-0" },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.hideEmptyLayouts,
                              expression: "hideEmptyLayouts",
                            },
                          ],
                          staticClass: "form-check-input",
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.hideEmptyLayouts)
                              ? _vm._i(_vm.hideEmptyLayouts, null) > -1
                              : _vm.hideEmptyLayouts,
                          },
                          on: {
                            change: [
                              function ($event) {
                                var $$a = _vm.hideEmptyLayouts,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.hideEmptyLayouts = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.hideEmptyLayouts = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.hideEmptyLayouts = $$c
                                }
                              },
                              _vm.emitFilters,
                            ],
                          },
                        }),
                        _vm._v(
                          "\n              Hide empty layouts\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group align-items-center lm-filters__row",
                  },
                  [
                    _c("label", { staticClass: "mb-0 cursor-pointer" }, [
                      _vm._v("ID"),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.otherFilters["ID"],
                            expression: "otherFilters['ID']",
                          },
                        ],
                        staticClass: "form-control w-100",
                        attrs: { type: "text" },
                        domProps: { value: _vm.otherFilters["ID"] },
                        on: {
                          input: [
                            function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.otherFilters,
                                "ID",
                                $event.target.value
                              )
                            },
                            _vm.emitFiltersDebounced,
                          ],
                        },
                      }),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group align-items-center lm-filters__row",
                  },
                  [
                    _c("label", { staticClass: "mb-0 cursor-pointer" }, [
                      _vm._v("Customer"),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "div",
                        {
                          ref: "customerDropdown",
                          staticClass: "layouts-customer-filter",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "form-control layouts-customer-filter__button",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  _vm.customersOpen = !_vm.customersOpen
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.selectedCustomersLabel)),
                              ]),
                              _vm._v(" "),
                              _c("i", { staticClass: "bi bi-chevron-down" }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.customersOpen,
                                  expression: "customersOpen",
                                },
                              ],
                              staticClass: "layouts-customer-filter__menu",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                                mousedown: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "layouts-customer-filter__search",
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value: _vm.customerSearch,
                                        expression: "customerSearch",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "search",
                                      placeholder: "Search customer...",
                                    },
                                    domProps: { value: _vm.customerSearch },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.customerSearch =
                                          $event.target.value.trim()
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "layouts-customer-filter__option",
                                },
                                [
                                  _c("input", {
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: !_vm.selectedCustomers.length,
                                    },
                                    on: { change: _vm.selectAllCustomers },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("All layouts")]),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.filteredCustomers,
                                function (customer) {
                                  return _c(
                                    "label",
                                    {
                                      key: customer.id,
                                      staticClass:
                                        "layouts-customer-filter__option",
                                    },
                                    [
                                      _c("input", {
                                        attrs: { type: "checkbox" },
                                        domProps: {
                                          value: String(customer.id),
                                          checked:
                                            _vm.selectedCustomers.includes(
                                              String(customer.id)
                                            ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.toggleCustomer(
                                              customer.id,
                                              $event.target.checked
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(customer.name)),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                              _vm._v(" "),
                              !_vm.filteredCustomers.length
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "layouts-customer-filter__empty",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  No customers found\n                "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _vm._l(
                  _vm.textFilters.filter((f) => f.label !== "ID"),
                  function (filter) {
                    return _c(
                      "div",
                      {
                        key: filter.label,
                        staticClass:
                          "form-group align-items-center lm-filters__row",
                      },
                      [
                        _c("label", { staticClass: "mb-0 cursor-pointer" }, [
                          _vm._v(_vm._s(filter.label)),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.otherFilters[filter.label],
                                expression: "otherFilters[filter.label]",
                              },
                            ],
                            staticClass: "form-control w-100",
                            attrs: { type: "text" },
                            domProps: { value: _vm.otherFilters[filter.label] },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(
                                    _vm.otherFilters,
                                    filter.label,
                                    $event.target.value
                                  )
                                },
                                _vm.emitFiltersDebounced,
                              ],
                            },
                          }),
                        ]),
                      ]
                    )
                  }
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group align-items-center lm-filters__row",
                  },
                  [
                    _c("label", { staticClass: "mb-0 cursor-pointer" }, [
                      _vm._v("Sort by"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex", staticStyle: { gap: "8px" } },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.sortBy,
                                expression: "sortBy",
                              },
                            ],
                            staticClass: "form-control",
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.sortBy = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                _vm.onSortColumnChange,
                              ],
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(
                                "\n                Column\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.sortColumns, function (col) {
                              return _c(
                                "option",
                                {
                                  key: col.value,
                                  domProps: { value: col.value },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(col.label) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.sortOrder,
                                expression: "sortOrder",
                              },
                            ],
                            staticClass: "form-control w-auto",
                            attrs: { disabled: !_vm.sortBy },
                            on: {
                              change: [
                                function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.sortOrder = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                _vm.emitFilters,
                              ],
                            },
                          },
                          [
                            _c(
                              "option",
                              { attrs: { value: "", disabled: "" } },
                              [
                                _vm._v(
                                  "\n                Order\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "asc" } }, [
                              _vm._v("\n                Asc\n              "),
                            ]),
                            _vm._v(" "),
                            _c("option", { attrs: { value: "desc" } }, [
                              _vm._v("\n                Desc\n              "),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "form-group align-items-center lm-filters__row",
                  },
                  [
                    _c("label", { staticClass: "mb-0 cursor-pointer" }, [
                      _vm._v("Per page"),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: _vm.perPage,
                              expression: "perPage",
                              modifiers: { number: true },
                            },
                          ],
                          staticClass: "form-control w-50",
                          on: {
                            change: [
                              function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return _vm._n(val)
                                  })
                                _vm.perPage = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                              _vm.emitFilters,
                            ],
                          },
                        },
                        _vm._l(_vm.perPageOptions, function (option) {
                          return _c(
                            "option",
                            { key: option, domProps: { value: option } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(option) +
                                  "\n              "
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "lm-filters__footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-link p-0 lm-filters__clear",
                  attrs: { type: "button" },
                  on: { click: _vm.clearAll },
                },
                [_vm._v("\n          Clear all\n        ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "lm-filters__active" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.activeFiltersCount) +
                    " active\n        "
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-3" }, [
      _c("h6", { staticStyle: { color: "#495057" } }, [
        _vm._v("\n                Search in\n              "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-group form-check" }, [
      _c("label", { staticClass: "form-check-label cursor-pointer" }, [
        _c("input", {
          staticClass: "form-check-input",
          attrs: { type: "checkbox", checked: "", disabled: "" },
        }),
        _vm._v("\n                Layouts\n              "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }